import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

export class GridLayout extends Component {


  constructor(props) {
    super(props);

    this.center = {
      justifyContent: this.props.center ? "center" : "flex-start"
    };
  }

  render() {
    const wrapped_childs = React.Children.map(this.props.children, (child) => {
      const clone = React.cloneElement(child, {});
      return (
        <Col xs="12" sm="6" md="4" xl="3" className={ "pb-3" }>
          { clone }
        </Col>
      );
    });

    const { noGutters } = this.props;

    return (
      <Row noGutters={noGutters} style={this.center} className={this.props.single_row ? "single-row" : ""}>
        { wrapped_childs }
      </Row>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/layout/GridLayout.js